var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navBar'),(_vm.settings && _vm.settings.variables)?_c('div',{staticClass:"container is-fluid"},[_c('span',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.settings.variables.find((a) => a.key === 'faq').value)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }